import api from '@/apis/fr/frTemplateCustomAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('FrTemplateCustom', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fr_template_custom',
    field: {
      key: 'fr_template_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
